import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import { ThemeStore, type ThemeMode, type ThemeOption, THEME_OPTIONS } from 'shared';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-theme-selector',
  imports: [HlmPopoverImports, TranslatePipe, ThemedIconComponent],
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.scss',
})
export class ThemeSelectorComponent {
  private readonly themeStore = inject(ThemeStore);

  readonly themeMode = this.themeStore.themeMode;
  readonly isPopoverOpen = signal(false);

  readonly themeOptions: ThemeOption[] = Object.values(THEME_OPTIONS);
  readonly popoverId = 'theme-selector-popover';

  get currentIconName(): string {
    return THEME_OPTIONS[this.themeMode()].iconName;
  }

  get currentLabelKey(): string {
    return THEME_OPTIONS[this.themeMode()].labelKey;
  }

  onSelectTheme(mode: ThemeMode, ctx: { close: () => void }): void {
    this.themeStore.setThemeMode(mode);
    ctx.close();
  }

  onStateChanged(state: string): void {
    this.isPopoverOpen.set(state === 'open');
  }
}
